import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=f3c1003a&scoped=true&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"
import style0 from "./product_list.vue?vue&type=style&index=0&id=f3c1003a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c1003a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c1003a')) {
      api.createRecord('f3c1003a', component.options)
    } else {
      api.reload('f3c1003a', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=f3c1003a&scoped=true&", function () {
      api.rerender('f3c1003a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/price_maintenance/form/product_list.vue"
export default component.exports